import AddNewInline from "./modules/add-new-inline";

jQuery( () => {
	AdminColumns.AddNewInline = new AddNewInline();
} );